import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import { ChatbotAnswer, Feedback, TextButton } from './widgets';
const config = (initialMessage, screen, customComponents) => {
    return {
        initialMessages: [
            createChatBotMessage(initialMessage, {
                widget: 'textButton',
                payload: { screen },
            }),
        ],
        customComponents,
        customStyles: {
            chatButton: {
                backgroundColor: '#768d95',
            },
        },
        widgets: [
            {
                widgetName: 'textButton',
                widgetFunc: props => React.createElement(TextButton, { ...props }),
                props: {},
                mapStateToProps: [],
            },
            {
                widgetName: 'chatbotAnswer',
                widgetFunc: props => React.createElement(ChatbotAnswer, { ...props }),
                props: {},
                mapStateToProps: [],
            },
            {
                widgetName: 'feedback',
                widgetFunc: props => React.createElement(Feedback, { ...props }),
                props: {},
                mapStateToProps: [],
            },
        ],
    };
};
export default config;
